// This value is exported from valuation/shared as it's a lib that agent matcher
// and valuation both consume. It is designed to stay in the codebase for a
// longer period of time and to be turned off and on as each incremental change
// to agent matcher is made as a way for us to compare the two products without
// setting up and tearing down this complex experiment each time.

// When this is codified, there is also a duplicate of this in
// apps/website/edge-functions/routeHandlers/agentMatcher.ts that will need to
// be removed.
export const AgentMatcherNavExperiment = {
    FLAG: '_agent-matcher_global-nav-comparison',
    CONTROL: 'valuation',
    VARIANT: 'agent-matcher',
} as const;

// For Intercept Experiment - VEN-2079
export const ValuationInterceptExperiment = {
    FLAG: '_valuation_intercept_to_agent_matcher',
    CONTROL: 'control',
    VARIANT: 'intercept',
} as const;
